// رمزنگاری محلی حالت آفلاین (ARD-offline §۲؛ ADR-011؛ AP-OFF-01): AES-GCM ۲۵۶ با کلید WebCrypto «غیرقابل استخراج» (extractable=false).
// کلید هرگز به‌صورت بایت در دسترس اسکریپت نیست و فقط شیء CryptoKey در IndexedDB نگه داشته می‌شود؛ با خروج یا جابه‌جایی مستأجر همراه داده
// پاک می‌شود (C-AGENT-1547). هر رکورد IV تصادفی ۱۲ بایتی و AAD = دامنه (مستأجر|کاربر|نوع رکورد) دارد تا جابه‌جایی رکورد بین دامنه‌ها کشف شود.

/** رکورد رمزشده ذخیره‌شده (بدون هیچ متن روشن). */
export interface SealedRecord {
  v: 1;
  iv: Uint8Array;
  data: ArrayBuffer;
}

const ALGORITHM = 'AES-GCM';

function subtle(): SubtleCrypto {
  const value = globalThis.crypto?.subtle;
  if (!value) {
    throw new Error('webcrypto_unavailable');
  }
  return value;
}

/** کلید تازه AES-GCM ۲۵۶ غیرقابل استخراج. */
export async function createVaultKey(): Promise<CryptoKey> {
  return subtle().generateKey({ name: ALGORITHM, length: 256 }, false, ['encrypt', 'decrypt']);
}

const encoder = new TextEncoder();
const decoder = new TextDecoder();

/** رمز کردن مقدار JSON با AAD. */
export async function seal(key: CryptoKey, aad: string, value: unknown): Promise<SealedRecord> {
  const iv = globalThis.crypto.getRandomValues(new Uint8Array(12));
  const data = await subtle().encrypt(
    { name: ALGORITHM, iv, additionalData: encoder.encode(aad) },
    key,
    encoder.encode(JSON.stringify(value)),
  );
  return { v: 1, iv, data };
}

/** گشودن رکورد؛ AAD یا کلید نادرست ← خطا (دستکاری یا دامنه دیگر). */
export async function unseal<T>(key: CryptoKey, aad: string, record: SealedRecord): Promise<T> {
  const plain = await subtle().decrypt(
    { name: ALGORITHM, iv: record.iv as Uint8Array<ArrayBuffer>, additionalData: encoder.encode(aad) },
    key,
    record.data,
  );
  return JSON.parse(decoder.decode(plain)) as T;
}

/** رکورد ذخیره‌شده ظاهر رمزشده دارد (نه شیء JSON روشن). */
export function isSealed(value: unknown): value is SealedRecord {
  if (typeof value !== 'object' || value === null || (value as SealedRecord).v !== 1) {
    return false;
  }
  // بررسی بدون instanceof (اشیای WebCrypto و IndexedDB ممکن است از Realm دیگری باشند).
  const { iv, data } = value as SealedRecord;
  return ArrayBuffer.isView(iv) && Object.prototype.toString.call(data) === '[object ArrayBuffer]';
}
